import React, { Component } from 'react';
import {Card, CardText} from 'material-ui/Card';
import {Row, Col} from 'react-flexbox-grid/lib';

import * as settings from 'settings/settings';
import styles from './styles/GoogleMapLoadSinglePinStyles';
import SpinnerLoaderWithText from 'components/loaders/SpinnerLoaderWithText';
import GoogleMapIcnSinglePin from 'components/maps/GoogleMapIcnSinglePin';
import moment from 'moment';
import {convertMiPerHourToKmPerHour} from 'services/systemOfUnitsServices';

/**
 * carica pin singolo
*/
class SinglePin extends Component {
    constructor(props){
        super(props)
        this.onToggleOpen = this.onToggleOpen.bind(this);

        this.state = {
            isOpen: false
        };
    }

    /**
     * gestisce la chiusura o apertura dell'info windows del pin
    */
    onToggleOpen(){
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {

        console.info("google map single pin container rendered");

        var {icn, icnPlus, currentLanguage, isMilesPerHour, pdof, translate} = this.props;

        var gpsposition = { lat: -34.397, lng: 150.644 };
        var addres = "";
        var dateTime = null;
        /*
            la velocità salvata nell'icn è sempre in miles per hour
        */
        var speed;
        var unitOfMeaserLabel = translate('GLOBAL.miph');

        if(icn)
        {
            speed = icn.speed;
            gpsposition = { lat: icn.latitude, lng: icn.longitude };
            addres = icn.address;

            var momentutc = moment.utc(icn.crashDate);
            momentutc.locale(currentLanguage);

            dateTime = "UTC " + momentutc.format("L") + " " + momentutc.format("LT");

            if(!isMilesPerHour)
            {
                speed = parseFloat(convertMiPerHourToKmPerHour(icn.speed));
                unitOfMeaserLabel = translate('GLOBAL.kmph');
            }
        }

        return (
            <div>
                {icn ?
                    <Row style={styles.mapContainer} >
                        <Col xs={12}>
                            <Card initiallyExpanded={true}>
                                <CardText expandable={true} >
                                    <GoogleMapIcnSinglePin isMarkerShown={icn !== null}
                                        position={gpsposition}
                                        addres={addres}
                                        dateTime={dateTime}
                                        icnPlus={icnPlus}
                                        pdof={pdof}
                                        isMilesPerHour={isMilesPerHour}
                                        speed={speed}
                                        unitOfMeaserLabel={unitOfMeaserLabel}
                                        icnId = {icn.id}
                                        isOpen={this.state.isOpen}
                                        onToggleOpen={this.onToggleOpen}
                                        googleMapURL={settings.googleMapUrl}
                                        loadingElement={<div style={{ height: `100%` }} />}
                                        containerElement={<div style={{ height: `600px` }} />}
                                        mapElement={<div style={{ height: `100%` }} />} />
                                </CardText>
                            </Card>
                        </Col>
                    </Row>
            :
                <SpinnerLoaderWithText />
            }
            </div>
        );
    }
}

// icn, icnPlus, currentLanguage, isMilesPerHour, pdof, translate
SinglePin.propTypes = {

};

export default SinglePin;


// WEBPACK FOOTER //
// ./src/containers/maps/SinglePin.js